import { render, staticRenderFns } from "./MobilePrefixes.vue?vue&type=template&id=22fbdd08&"
import script from "./MobilePrefixes.vue?vue&type=script&lang=js&"
export * from "./MobilePrefixes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports